import Fuse from 'fuse.js';
import { useState, useMemo } from 'react';
import { getSearchableContent } from '../data/helpContent';

export function useHelpSearch() {
    const [query, setQuery] = useState('');

    const fuse = useMemo(() => new Fuse(getSearchableContent(), {
        keys: [
            { name: 'title', weight: 3 },
            { name: 'keywords', weight: 2 },
            { name: 'summary', weight: 1.5 },
            { name: 'body', weight: 1 },
        ],
        threshold: 0.4,
        includeScore: true,
        includeMatches: true,
    }), []);

    const results = query.length >= 2 ? fuse.search(query).slice(0, 10) : [];

    return { query, setQuery, results };
}
